import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updateInvoiceField } from '../../../actions'
import CheckboxDropdown from './CheckboxDropdown'

const InvList = (props) => {
    
    const dispatch = useDispatch()

    const invoiceList = useSelector((state) => {
        return state.InvoicesReducer?.invoices?.map((itm, idx) => ({
            id: itm?.invoiceId,
            title: `INVOICE-00${idx + 1}`,
            isChecked: itm.isChecked
        }))
    })

    const toggleSelection = (e, { id, label, checked }) => {
        dispatch(updateInvoiceField(id, { isChecked: checked }))
    }

    return (
        <CheckboxDropdown
            label={'INVOICES'}
            itemList={invoiceList}
            toggleSelection={toggleSelection}
        />
    )
}

export default InvList